import React from 'react';
import { ArrowUpRight, MapPin } from 'lucide-react';
import { LINKS } from '../lib/links';
import { FadeIn } from './FadeIn';
import { IllustratedMap } from './IllustratedMap';
const DISTANCES = [{
  place: 'Tel Aviv',
  time: '45 min'
}, {
  place: 'Haifa',
  time: '35 min'
}, {
  place: 'Pardes Hanna',
  time: '8 min'
}];
export function Location() {
  return <section id="location" className="relative scroll-mt-20 bg-cream px-6 py-20 md:px-12 md:py-32" data-id="element-442" data-mp="qvcbk4wapvzy">
      <div className="mx-auto max-w-6xl" data-id="element-443" data-mp="hsuqvuwahbf2">
        <div className="grid grid-cols-1 items-center gap-12 lg:grid-cols-12 lg:gap-16" data-id="element-444" data-mp="htmm34lz574t">
          <div className="lg:col-span-7" data-id="element-445" data-mp="34zt403fcgv4">
            <FadeIn data-id="element-446" data-mp="31u7wvxx1z4o">
              <div className="overflow-hidden rounded-sm border border-pine/10" data-id="element-447" data-mp="82ry9vt2xzh9">
                <IllustratedMap data-id="element-448" data-mp="80ow6denkfw6" />
              </div>
            </FadeIn>
          </div>

          <div className="lg:col-span-5" data-id="element-449" data-mp="3qar3nbid9c9a">
            <FadeIn data-id="element-450" data-mp="3uarll64oc5l3">
              <p className="mb-4 text-xs font-medium uppercase tracking-[0.2em] text-clay/70" data-id="element-451" data-mp="3u8ya9dj48x6r">
                Location
              </p>
            </FadeIn>
            <FadeIn delay={0.1} data-id="element-452" data-mp="uanxtiuuoqd9">
              <h2 className="mb-6 font-serif text-4xl leading-tight text-pine md:text-5xl" data-id="element-453" data-mp="u9dxso4ft83z">
                Kfar Pines.
              </h2>
            </FadeIn>
            <FadeIn delay={0.2} data-id="element-454" data-mp="148ljpzp8mb2p">
              <p className="mb-10 text-lg font-light leading-relaxed text-clay" data-id="element-455" data-mp="149mwq9ptd7n2">
                Tucked into the trees on the moshav — far enough to feel away, close
                enough to reach after work.
              </p>
            </FadeIn>

            <FadeIn delay={0.25} data-id="element-456" data-mp="bi37o96jczd5">
              <dl className="mb-10 border-t border-pine/15" data-id="element-457" data-mp="q9c71a08pz3h">
                {DISTANCES.map(distance => <div key={distance.place} className="flex items-baseline justify-between border-b border-pine/15 py-4" data-id="element-458" data-mp="lhu6gn24q0j1">
                    <dt className="font-light text-clay" data-id="element-459" data-mp="3ozcaskip0pep">{distance.place}</dt>
                    <dd className="font-serif text-2xl text-pine" data-id="element-460" data-mp="ihk5supegsjw">{distance.time}</dd>
                  </div>)}
              </dl>
            </FadeIn>

            <FadeIn delay={0.3} data-id="element-461" data-mp="mhm9tailxy2c">
              <a href={LINKS.googleMaps} target="_blank" rel="noopener noreferrer" className="group inline-flex items-center gap-3 rounded-sm bg-pine px-6 py-3.5 font-medium tracking-wide text-cream transition-colors hover:bg-pineDeep" data-id="element-462" data-mp="r9vuab0ye5x8">
                <MapPin className="h-4 w-4" data-id="element-463" data-mp="3jrru6zi4c7t" />
                Get directions
                <ArrowUpRight className="h-4 w-4 opacity-70 transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5" data-id="element-464" data-mp="3m4gf2zrlktu" />
              </a>
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
}